import { Company } from './company.types';

export enum StakeholderRole {
  ADMIN = 'admin',
  CONTRIBUTOR = 'contributor',
  STAKEHOLDER = 'stakeholder',
}
export enum StakeholderOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum StakeholderSortBy {
  COMPANY = 'company',
  NAME = 'fullName',
  STATUS = 'status',
}

export enum StakeholderType {
  ADVISOR = 'advisor',
  ANGEL = 'angel',
  BOARD_MEMBERS = 'board-members',
  EMPLOYEE = 'employee',
  FAMILY_OFFICE = 'family-office',
  FOUNDER = 'founder',
  INVESTMENT_BANKS = 'investment-banks',
  OTHER_INST = 'other-inst',
  PES = 'pes',
  SPV = 'spv',
  VCS = 'vcs',
}

export const stakeholderTypeTitle: Record<StakeholderType, string> = {
  [StakeholderType.ADVISOR]: 'Advisors',
  [StakeholderType.ANGEL]: 'Angels',
  [StakeholderType.EMPLOYEE]: 'Employees',
  [StakeholderType.FOUNDER]: 'Founders',
  [StakeholderType.BOARD_MEMBERS]: 'Board Member',
  [StakeholderType.VCS]: 'Venture Capital',
  [StakeholderType.INVESTMENT_BANKS]: 'Investment Bank',
  [StakeholderType.PES]: 'Private Eq Firm',
  [StakeholderType.FAMILY_OFFICE]: 'Family Office',
  [StakeholderType.SPV]: 'SPV',
  [StakeholderType.OTHER_INST]: 'Others',
};

export const stakeholderExTypeTitle: Record<StakeholderType, string> = {
  [StakeholderType.ADVISOR]: 'Ex-Advisor',
  [StakeholderType.ANGEL]: '',
  [StakeholderType.EMPLOYEE]: 'Ex-Employee',
  [StakeholderType.FOUNDER]: 'Ex-Founder',
  [StakeholderType.BOARD_MEMBERS]: '',
  [StakeholderType.VCS]: '',
  [StakeholderType.INVESTMENT_BANKS]: '',
  [StakeholderType.PES]: '',
  [StakeholderType.FAMILY_OFFICE]: '',
  [StakeholderType.SPV]: '',
  [StakeholderType.OTHER_INST]: '',
};

export const stakeholderTypeTitleMap = Object.entries(stakeholderTypeTitle);

export const stakeholderRoleTitle: Record<StakeholderRole, string> = {
  [StakeholderRole.ADMIN]: 'Admin',
  [StakeholderRole.CONTRIBUTOR]: 'Contributor',
  [StakeholderRole.STAKEHOLDER]: 'Stakeholder',
};

export const stakeholderRoleTitleMap = Object.entries(stakeholderRoleTitle);

export enum TerminationCause {
  DEATH = 'death',
  DISABILITY = 'disability',
  RESIGNATION = 'resignation',
  RETIREMENT = 'retirement',
  TERMINATION = 'termination',
  TERMINATION_WITH_CAUSE = 'termination-with-cause',
}

export const TerminationCauseTitle: Record<TerminationCause, string> = {
  [TerminationCause.RESIGNATION]: 'Resignation',
  [TerminationCause.TERMINATION]: 'Termination',
  [TerminationCause.TERMINATION_WITH_CAUSE]: 'Termination With Cause',
  [TerminationCause.RETIREMENT]: 'Retirement',
  [TerminationCause.DEATH]: 'Death',
  [TerminationCause.DISABILITY]: 'Disability',
};

export enum StakeholderBulkAction {
  CANCEL_INVITATION = 'cancel-invitation',
  DELETE = 'delete',
  INVITE = 'invite',
  TOGGLE_ACCESS = 'toggle-access',
  TOGGLE_CONTRIBUTOR = 'toggle-contributor',
}

export type StakeholderBulkActionDto = {
  stakeholderIds: string[];
};

export interface Stakeholder {
  address?: string;
  birthday?: string;
  capitalChangeAccess: boolean;
  capTableAccess: boolean;
  company?: Company;
  companyId?: string;
  companyTableAccess: boolean;
  countryOfInc?: unknown;
  createdAt: string;
  deletedAt?: string;
  email: string;
  fullName: string;
  id: string;
  incDate?: string;
  isAccessRevoked: boolean;
  isActive: boolean;
  isInvited: boolean;
  isTerminated: boolean;
  lastActive: string;
  lastVestingDate?: string;
  nationalityCountry?: unknown;
  passportExpDate?: string;
  passportNo?: string;
  phone?: string;
  phoneCountryIso2?: string;
  positionAccess: boolean;
  role: StakeholderRole;
  stakeholderCompanyId?: string;
  terminationCause?: TerminationCause;
  terminationDate?: string;
  type: StakeholderType;
  votingRightsPercentage?: number;
}
